import React, { Component } from 'react';
import { sessionManager } from '../../core/SessionManager';
import { Card, Col, Row, notification, Spin } from 'antd';
import api from '../../utils/api';
import moment from 'moment';
import { post } from '../../utils/http';
import infoSrc from '../img/info.png';

let privilege;
class Home extends Component {

	constructor(props) {
		privilege = sessionManager.getPrivilege();
		super(props)
		this.state = {
			role: sessionManager.getUserRole(),
			merchantId: sessionManager.getMerchantId(),
			time: moment().format('DD MMMM YYYY HH:mm A'),
			totalWalletBalance: '0.00',
			totalCFOWalletBalance: '0',
			totalTransaction: '0',
			totalAreaNumber: '0',
			totalOutletNumber: '0',
			totalDivisionNumber: '0',
			totalApproveTransaction: '0',
			totalFailedTransaction: '0',
			lastAutoCashOutDate: '',
			nextAutoCashOutDate: '',
			loading:false
		}
	}

	cardBodyStyle = {padding:'12px'};
	cardHeadStyle = {paddingLeft:'12px'};

	componentDidMount() {
		const { 
			merchantId, 
		} = this.state;
		let _this = this;
		let confirmData = new FormData();
        confirmData.append("merchantId", merchantId);
		if (this.state.role === '3') {
			this.setState({loading:true});
			post(api.initHomePageData, confirmData).then(function (response) {
				_this.setState({loading:false});
				var { 
					totalWalletBalance, 
					totalCFOWalletBalance, 
					totalTransaction,
					totalAreaNumber,
					totalOutletNumber,
					totalDivisionNumber,
					totalApproveTransaction,
					totalFailedTransaction,
					lastAutoCashOutDate,
					nextAutoCashOutDate
				} = response;
				_this.setState({
					totalWalletBalance: totalWalletBalance, 
					totalCFOWalletBalance: totalCFOWalletBalance, 
					totalTransaction: totalTransaction,
					totalAreaNumber: totalAreaNumber,
					totalOutletNumber: totalOutletNumber,
					totalDivisionNumber: totalDivisionNumber,
					totalApproveTransaction: totalApproveTransaction,
					totalFailedTransaction: totalFailedTransaction,
					lastAutoCashOutDate: lastAutoCashOutDate,
					nextAutoCashOutDate: nextAutoCashOutDate
				})
			}).catch(function (error) {
				_this.setState({loading:false});
				notification['error']({
					message: 'Fail to init Home Page Data.',
				});
			})
		}
	}

	componentWillUnmount(){
		
	}

	render() {

		const { 
			role, 
			totalWalletBalance, 
			totalTransaction,
			totalAreaNumber,
			totalOutletNumber,
			totalDivisionNumber,
			totalApproveTransaction,
			lastAutoCashOutDate,
			nextAutoCashOutDate,
		} = this.state;
		return <div style={{ height: "auto" }}>
			{(role === '1' || role === '2') && <div style={{ height: "400px" }}>
		 	Hi {sessionManager.getUserInfo().userName}, Welcome to Merchant Portal.
		 	</div>}

			{(role === '3') && 
			<div className="site-card-wrapper">
				<Row style={{marginBottom:10}} gutter={16}>
				<Col span={24}>
					<Card title="Overview" bordered={true} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
					{<span style={{fontSize:14, lineHeight:1}}>Summary as of {this.state.time}</span>}
					</Card>
				</Col>
				</Row>
				{privilege && privilege.displayTaxiCFO ==false && 
					<Row style={{marginBottom:10}} gutter={16}>
					<Col span={12}>
						<Card title={<span>Total Balance<a href='#' title="This reflects the total amount of transactions since last cashout."><img src={infoSrc}/></a>:</span>} bordered={false} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
						{<span style={{fontSize:20,color:'#03a3e4', lineHeight:1.2}}>SGD {totalWalletBalance}</span>}
						</Card>
					</Col>
					<Col span={12}>
						<Card title="Partner Display Name:" bordered={false} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
						{<span style={{fontSize:14, lineHeight:1.8}}>{sessionManager.getMerchantName()}</span>}
						</Card>
					</Col>
					</Row>
				}
				{privilege && privilege.displayTaxiCFO ==true && 
					<Row style={{marginBottom:10}} gutter={16}>
					<Col span={24}>
						<Card title="Partner Display Name:" bordered={false} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
						{<span style={{fontSize:14, lineHeight:3}}>{sessionManager.getMerchantName()}</span>}
						</Card>
					</Col>
					</Row>
				}
				{privilege && privilege.displayTaxiDriver ==true && privilege.displayTaxiCFO==true &&
					<Row style={{marginBottom:10}} gutter={16}>
					<Col span={12}>
						<Card title={<span>Total Balance<a href='#' title="This reflects the total amount of transactions since last cashout."><img src={infoSrc}/></a>:</span>} bordered={false} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
						{<span style={{fontSize:36,color:'#03a3e4', lineHeight:1.2}}>SGD {totalWalletBalance}</span>}
						</Card>
					</Col>
					<Col span={12}>
						<Card title="Approved Transactions:" bordered={false} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
						{<span style={{fontSize:20, lineHeight:3}}>{totalApproveTransaction}</span>}
						</Card>
					</Col>
					</Row>
				}
				{privilege && privilege.isTaxi == false &&
				<Row style={{marginBottom:10}} gutter={16}>
				{privilege.displayViewTransaction && 
				<Col span={12}>
					<Card title={<span>Total Transactions<a href='#' title="This reflects the  total number of transactions since last cashout.."><img src={infoSrc}/></a>:</span>} bordered={false} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
					{<span style={{fontSize:20, color:'#03a3e4', lineHeight:0.7}}>{totalTransaction}</span>}
					</Card>
				</Col>}
				{privilege.displayHomePageAreaNumber && 
				<Col span={6}>
					<Card title="No. of Area(s):" bordered={false} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
					{<span style={{fontSize:20, lineHeight:0.8}}>{totalAreaNumber}</span>}
					</Card>
				</Col>}
				{privilege.displayHomePageOutletNumber && 
				<Col span={6}>
					<Card title="No. of Outlet(s):" bordered={false} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
					{<span style={{fontSize:20, lineHeight:0.8}}>{totalOutletNumber}</span>}
					</Card>
				</Col>}
				</Row>}
				<Row style={{marginBottom:10}} gutter={16}>
				{privilege.displayDivisionTab && 
				<Col span={12}>
					<Card title="No. of Division(s):" bordered={false} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
						{<span style={{fontSize:20, lineHeight:2.2}}>{totalDivisionNumber}</span>}
					</Card>
				</Col>}
				{privilege.displayTaxiCFO == false && privilege.displaySweepOut && 
				<Col span={12}>
					<Card title="Cash Out:" bordered={false} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
					{<div><span style={{fontSize:14, lineHeight:1}}>Last auto cash out was conducted on {lastAutoCashOutDate}</span></div>}
					{<div><span style={{fontSize:14, lineHeight:1}}>Next auto cash out is scheduled on {nextAutoCashOutDate}</span></div>}
					</Card>
				</Col>}
				</Row>
				{privilege && privilege.displayTaxiCFO == true &&
				<Row style={{marginBottom:10}} gutter={16}>
				<Col span={24}>
					<Card title="Cash Out:" bordered={false} bodyStyle={this.cardBodyStyle} headStyle = {this.cardHeadStyle}>
					{<div><span style={{fontSize:16, lineHeight:1.5}}>Last auto cash out was conducted on {lastAutoCashOutDate}</span></div>}
					{<div><span style={{fontSize:16, lineHeight:1.5}}>Next auto cash out is scheduled on {nextAutoCashOutDate}</span></div>}
					</Card>
				</Col>
				</Row>}
				{ this.state.loading && <div style={{position:"absolute",top:'40%',left:'50%'}}> <Spin></Spin> </div>}
		  </div>}
		</div>
	}
}

export default Home;